<nb-icon class="catalog-show__icon" *ngIf="!storeService.getTreeOpen()"
         nbTitle="Показать дерево" (click)="storeService.toggleTree()"
         icon="menu-arrow-outline"></nb-icon>
